import React from "react";
import { NavLink } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Logo from "../../images/logo.png";
import { cn } from "@/lib/utils";

/**
 * Reusable authentication header component
 * Used across login, signup, password reset, and other auth pages
 * 
 * @param {Object} props
 * @param {boolean} props.showHowItWorks - Show "How it Works?" button (default: true)
 * @param {string} props.className - Additional CSS classes
 */
const SignupHeader = ({ showHowItWorks = true, className }) => {
  const isPopup = window.opener;

  return (
    <header 
      className={cn(
        "w-full bg-transparent",
        className
      )}
    >
      <div className="w-full mx-auto px-12 py-6 flex items-center justify-between">
        {/* Logo */}
        {isPopup ? (
          <div className="flex items-center">
            <img 
              src={Logo} 
              alt="NuLifeSpan Rx Logo" 
              className="h-8 md:h-10 object-contain"
            />
          </div>
        ) : (
          <NavLink 
            to="/" 
            className="flex items-center hover:opacity-80 transition-opacity"
          >
            <img 
              src={Logo} 
              alt="NuLifeSpan Rx Logo" 
              className="h-8 md:h-10 object-contain"
            />
          </NavLink>
        )}

        {/* How It Works Button */}
        {!isPopup && showHowItWorks && (
          <Button 
            variant="outline" 
            size="sm"
            className="font-medium text-foreground border-accent hover:text-accent"
            asChild
          >
            <a 
              href="https://www.nulifespanrx.com/how-it-works" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              How it Works?
            </a>
          </Button>
        )}
      </div>
    </header>
  );
};

export default SignupHeader;
